import { http } from 'http';
import { createPaginationQuery } from 'helpers/store';

export default {
  fetch: ({ pagination }) => http.get(`/campaigns${createPaginationQuery(pagination)}`),

  fetchSummary: () => http.get('/campaigns/summary'),

  campaignFrontById: (campaignId, partnerId, operationId, collapse, flow) => {
    let url = `/webh/campaigns/front/${campaignId}/${partnerId}`;
    if (operationId) {
      url = `/webh/campaigns/front/${campaignId}/${partnerId}?operationId=${operationId}`;
    }
    if (collapse) {
      url += `?format[eqs]=collapse&flow[eqs]=${flow}`;
    }
    return http.get(url);
  },

  getMasterData: () => http.get('/masterdata'),

  getTownsByCp: cp => http.get(`/towns/${cp}`),

  getClientsCampaignById: campaignId => http.get(`/campaigns/${campaignId}/clients`),

  getClientsByPartner: partnerId => http.get(`/clients/${partnerId}`),

  getCampaignById: campaignId => http.get(`/campaigns/${campaignId}`),

  getCampaignsOData: odataQuery => http.get(`/campaigns/odata?${odataQuery}`),

  getCarFeatures: campaignId => http.get(`/webh/campaigns/${campaignId}/carfeatures`),

  getNewCampaignData: campaignId => http.get(`/campaigns/quote/${campaignId}`),

  getTemplatesByCampaign: ({ partnerId, campaignId }) =>
    http.get(`/templates/${partnerId}/campaign/${campaignId}`),

  getGalleryByCampaignId: campaignId => http.get(`/VehicleImages/campaign/${campaignId}`)
};
